// Polyfill Node-style `global` for CJS deps (sockjs-client, etc.).
// Imported as the very first side-effect in src/index.tsx so this runs
// before any other module evaluates — ESM imports are hoisted and evaluated
// depth-first in source order, and this file has no imports of its own.
//
// Previously handled via `define: { global: "globalThis" }` in vite.config.ts,
// but esbuild's text replacement rewrote the property key `global` inside
// `jQuery.event = { global: {}, ... }` to `globalThis`, making
// `jQuery.event.global` undefined and breaking every `.on("click", ...)` call.
if (typeof window !== "undefined" && typeof (window as any).global === "undefined") {
  (window as any).global = window;
}

export {};
